module.exports = __webpack_public_path__ + "static/img/relationNew1.e2d22fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/relation/relationNew1.jpg
// module id = dCsl
// module chunks = 0